import { createSelector } from 'reselect';
import get from 'lodash/get';
import { v4 as uuidv4 } from 'uuid';
import {
  data as dataSelector,
  data2 as data2Selector,
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import {
  BACKEND_KEY,
  CHILDREN_CRUD_OVERVIEW,
} from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';
import dictionarySelector from '../../Summaries/SummaryDictionarySelector';
import { ENROLLMENT_AGE } from '../../Summaries/SummaryConstants';

export default createSelector(dataSelector, data =>
  (data(`${BACKEND_KEY}.Dependents`) || []).map(child => {
    if (child.frontEndId) {
      return child;
    }
    return {
      ...child,
      frontEndId: uuidv4(),
    };
  }),
);

export const isEmptyStateSelector = createSelector(
  dataSelector,
  data => (data(`${BACKEND_KEY}.Dependents`) || []).length <= 0,
);

export const viewIDSelector = createSelector(
  data2Selector,
  data2 => data2(`${BACKEND_KEY}.ChildrenStepViewID`) || CHILDREN_CRUD_OVERVIEW,
);

export const nextIteratorsSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
  dictionarySelector,
  (supportData, previousSupportData, dictionary) => {
    const child = get(supportData, 'PersonalInfo.SelectedChildFirstName', null);
    const previousChild = get(previousSupportData, 'PersonalInfo.SelectedChildFirstName', null);
    if (child !== previousChild) {
      return [ENROLLMENT_AGE].map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);
